<<template>
  <div style="overflow:hidden;">
    <div>
      <span class="xbed-sub-title">星创俱乐部</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem href="/">蓝主人</BreadcrumbItem>
        <BreadcrumbItem>星创俱乐部</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <br>
    <Form inline>
      <Row>
        <FormItem label="创建日期" :label-width="84">
          <DatePicker style="width: 200px" type="daterange" :options="dateOptions" v-model="dateArr" @on-change="changeDate" format="yyyy/MM/dd" placeholder="请选择日期"></DatePicker>
        </FormItem>
        <FormItem label="名称" :label-width="84">
          <Input style="width: 200px" v-model="search.clubName" placeholder="俱乐部名称" :maxlength="30"></Input>
        </FormItem>
        <FormItem label="编号" :label-width="100">
          <Input style="width: 200px" v-model="search.clubNo"  placeholder="俱乐部编号" :maxlength="255"></Input>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="创客成员" :label-width="84">
          <Input style="width: 200px" v-model="search.maker" placeholder="姓名／手机号" :maxlength="255"></Input>
        </FormItem>
        <FormItem label="开发员" :label-width="84">
          <Input style="width: 200px" v-model="search.developer" placeholder="姓名／手机号" :maxlength="255"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" :loading="searchBtnStatus" @click="queryWithKeyword">查询</Button>
        </FormItem>
      </Row>
    </Form>
    <Table height="450" stripe :columns="clubCloumns" :data="clubList.data"></Table>
    <div style="float: left;margin: 10px;overflow: hidden">
      <Page show-sizer placement="top" :total="clubList.count" :current="clubList.page" :page-size="clubList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
    </div>
    <Modal v-model="clubMemberModal" width="800" title="俱乐部成员" @on-cancel="cancelModel">
      <Row>
        <Col span="3">俱乐部名称</Col>
        <Col span="4">{{currentClub?currentClub.clubName:''}}</Col>
      </Row>
      <br>
      <Row>
        <Col span="16">
          <Page show-sizer placement="top" :total="clubMemberList.data.length" :current="clubMemberList.page" :page-size="clubMemberList.pageSize" @on-page-size-change="changeMemberPageSize" @on-change="changeMemberPage"></Page>
        </Col>
        <Col span="8">
          <span>查找</span> &nbsp;<Input ref="searchInput" style="width: 200px"  placeholder="输入姓名检索" @on-keyup="fuzzySearch"></Input>
        </Col>
      </Row>
      <br>
      <Table stripe height="250" stripe :columns="clubMemberColumns" :data="clubMemberList.list"></Table>
      <div slot="footer"></div>
    </Modal>
    <Modal v-model="editClubModal" :loading="true" ref="editClubNameModal" width="540" title="编辑俱乐部" @on-cancel="cancelModel" @on-ok="editClubNameEvent">
      <Row>
        <Col span="3">编号</Col>
        <Col span="10">{{editClub.clubNo}}</Col>
      </Row>
      <br>
      <Row>
        <Col span="3">名称</Col>
        <Col span="18">
          <Input style="width:200px" :maxlength="30" v-model="editClub.clubName" placeholder="俱乐部名称" @on-change="changeName"></Input> &nbsp;<a @click="checkName">检测名称</a>
        </Col>
      </Row>
      <Row>
        <Col span="3">&nbsp;</Col>
        <Col v-if="showNameStatus" span="10"><span v-bind:style="{fontSize:'12px',color:(clubNameStatus?'green':'red')}">{{clubNameStatus?'√ 该名称可以使用':'！该名称已有俱乐部使用，换一个再试'}}</span></Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
import Utils from "../../../utils";
import Moment from 'moment'
import API from "../../../api";

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.hasPower = Utils.hasPermission('oms_Owner_Club_edit');
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.queryClubList();
  },
  data(){
    return {
      dateOptions: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      },
      search: {
        clubName: "",
        clubNo: "",
        developer: "",
        endDate: "",
        maker: "",
        page: 1,
        size: 10,
        startDate: ""
      },
      dateArr: [],
      searchBtnStatus: false,
      editClub: {
        clubName: "",
        clubNo: "",
        id: ""
      },
      clubCloumns: [
        {
          title: 'ID',
          key: 'id',
          width: 200,
          align: 'center'
        },
        {
          title: '所属创客',
          key: 'maker',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', `${params.row.makerName}-${params.row.makerMobile}`)
          }
        },
        {
          title: '开发员',
          width: 200,
          key: 'developer',
          align: 'center',
          render: (h, params) => {
            return h('div', `${params.row.developerName}-${params.row.developerMobile}`)
          }
        },
        {
          title: '俱乐部名称',
          key: 'clubName',
          width: 200,
          align: 'center'
        },
        {
          title: '编号',
          key: 'clubNo',
          width: 200,
          align: 'center'
        },
        {
          title: '俱乐部人数',
          key: 'memberNum',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  width: '60px'
                },
                on: {
                  click: () => {
                    this.currentClub = params.row;
                    this.queryClubMemberList(params.row.id);
                    this.clubMemberModal = true;
                  }
                }
              }, params.row.memberNum)
            ])
          }
        },
        {
          title: '创建时间',
          key: 'createDate',
          width: 200,
          align: 'center',
          render: (h,params) => {
            return h('div',Moment(params.row.createDate).format('YYYY-MM-DD HH:mm:ss'))
          }
        },
        {
          title: '操作',
          key: 'operate',
          width: 200,
          align: 'center',
          render: (h,params) => {
            if(this.hasPower){
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.editClub = Object.assign(this.editClub,params.row);
                      this.editClubModal = true;
                    }
                  }
                }, '编辑')
              ])
            }
          }
        },
      ],
      clubList: {
        count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        data:[]
      },
      clubMemberColumns: [
        {
          title: '业主id',
          key: 'ownerId',
          width: 150,
          align: 'center'
        },
        {
          title: '姓名',
          key: 'ownerName',
          width: 150,
          align: 'center'
        },
        {
          title: '手机号',
          key: 'ownerMobile',
          width: 200,
          align: 'center'
        },
        {
          title: '备注',
          key: 'tips',
          width: 250,
          align: 'center',
          render: (h,params) => {
            return h('div',params.row.isClubOwner==1?'俱乐部拥有者':'加入时间：'+Moment(new Date(params.row.createDate)).format('YYYY-MM-DD HH:mm:ss'))
          }
        },
      ],
      clubMemberList: {
        data: [],
        store: [],
        list: [],
        //count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
      },
      currentClub: null,
      clubMemberModal: false,
      editClubModal: false,
      clubNameStatus: true,
      showNameStatus: false,
      isAllowEdit: false,
      subClubName: true,
    }
  },

  methods:{
    changePageSize(pageSize){
      this.search.page = 1;
      this.search.size = pageSize;
      this.queryClubList();
    },
    changePage(pageIndex){
      this.search.page = pageIndex;
      this.queryClubList();
    },
    changeDate(){
      this.search.startDate = new Date(Moment(this.dateArr[0]).format('YYYY-MM-DD')).getTime();
      this.search.endDate = new Date(Moment(this.dateArr[1]).format('YYYY-MM-DD')).getTime();
    },
    queryWithKeyword(){
      this.search.page = 1;
      this.queryClubList();
    },
    changeName(){
      this.showNameStatus = false;
      this.isAllowEdit = false;
    },
    editClubNameEvent(){
      this.$refs.editClubNameModal.buttonLoading = false;
      if(!this.isAllowEdit){
        this.$Notice.error({
          title: "请检查名称是否可用"
        });
      }else{
        this.editClubName();
      }
    },
    async editClubName(){
      let resp = (await API.omsAPI[this.env].bluehost.editClubName(
        this.editClub.clubName,
        this.editClub.id,
        this.username,
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: resp.msg
        });
      }else{
        this.$Notice.success({
          title: "修改成功"
        });
        this.editClubModal = false;
        this.showNameStatus = false;
      }
      this.queryClubList();
    },
    cancelModel(){
      this.clubMemberModal&&(this.clubMemberModal = false);
      this.editClubModal&&(this.editClubModal = false);
      this.showNameStatus = false;
    },
    async queryClubList(){
      this.search.endDate = this.dateArr[1]?Moment(this.dateArr[1]).format("YYYY-MM-DD"):"";
      this.search.startDate = this.dateArr[1]?Moment(this.dateArr[0]).format("YYYY-MM-DD"):"";
      let resp = (await API.omsAPI[this.env].bluehost.queryClubList(
        this.search,
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      this.clubList.data = resp.content;
      this.clubList.count = resp.totalPages;
      this.clubList.count = resp.totalElements;
    },
    async checkName(){
      this.isAllowEdit = false;
      if(this.editClub.clubName.trim().length==0){
        this.$Notice.error({
          title: '名称不能为空'
        })
        return false;
      }
      let resp = (await API.omsAPI[this.env].bluehost.checkClubName(
        this.editClub.clubName,
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: resp.msg
        });
      }else{
        this.showNameStatus = true;
        this.isAllowEdit = true;
        if(resp===true){
          this.clubNameStatus = true;
        }else{
          this.clubNameStatus = false;
        }
      }
    },
    async queryClubMemberList(id){
      let resp = (await API.omsAPI[this.env].bluehost.clubMemberList(
        id,
        this.token
      )).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: resp.msg
        });
      }else{
        this.clubMemberList.data = this.clubMemberList.store = resp;
        this.pagination(this.clubMemberList);
      }
    },
    changeMemberPageSize(pageSize){
      this.clubMemberList.pageSize = pageSize;
      this.clubMemberList.page = 1;
      this.pagination(this.clubMemberList);
    },
    changeMemberPage(page){
      this.clubMemberList.page = page;
      this.pagination(this.clubMemberList);
    },
    //分页
    pagination(){
      let obj = this.clubMemberList;
      if(obj.data.length<obj.pageSize) {
        obj.list = obj.data;
      }else {
        obj.list = obj.data.slice(obj.pageSize*(obj.page-1),obj.pageSize*obj.page)
      }
    },
    fuzzySearch(){
      let keyword = this.$refs.searchInput.currentValue;
      if(keyword.length>0) {
        let arr = this.clubMemberList.store;
        let newArr = [];
        for(let i=0;i<arr.length;i++){
          if(arr[i].ownerName.search(keyword)!=-1){
            newArr.push(arr[i]);
          }
        }
        this.clubMemberList.data = newArr;
      }else {
        this.clubMemberList.data = this.clubMemberList.store;
      }
      this.pagination();
    },
    matchByKeyword(keyword){
      let arr = this.clubMemberList.data;
      let newArr = [];
      for(let i=0;i<arr.length;i++){
        if(arr[i].ownerName.search(keyword)!=-1){
          newArr.push(arr[i]);
        }
      }
      this.clubMemberList.list = newArr;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/blue-hoster/star-club/index.vue